import { Component, AfterViewInit, ElementRef } from '@angular/core';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-compra',
  templateUrl: './compra.component.html',
  styleUrls: ['./compra.component.css']
})
export class CompraComponent implements AfterViewInit {

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const animatedEls: NodeListOf<Element> = this.el.nativeElement.querySelectorAll('.anim');
    animatedEls.forEach((el: Element) => observer.observe(el));
  }
}
